import { IconComponent } from 'src/types/icon';

const Check: IconComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 13" {...props}>
     <path fill={props.fill} d="m5.4 10.3-4-4L0 7.6 5.4 13 17.1 1.4 15.7 0 5.4 10.3z"/>
  </svg>
);

export default Check;
